module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.service_history_financial), function(history, index) {
    return _c('div', {
      staticClass: "box"
    }, [_c('article', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(history.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('pre', {
      domProps: {
        "innerHTML": _vm._s(history.history)
      }
    })]), (history.files.length > 0) ? _c('article', {
      staticClass: "media"
    }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("System")]), _vm._v(" "), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("Created: " + _vm._s(history.created_at))]), _vm._v(" "), _c('p')])])])])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('article', {
    staticClass: "media"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2db552","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/HistoryFinancial.vue
// module id = 1098
// module chunks = 39